import { Component, OnInit, Input } from '@angular/core';
import { SummaryRating } from 'app/shared/models/summaryRating.model';

@Component({
    selector: 'app-chart-completed-pc',
    templateUrl: './chart-completed-pc.component.html',
    styleUrls: ['./chart-completed-pc.component.css']
})
export class ChartCompletedPCComponent implements OnInit {
    @Input() completed: SummaryRating[];

    completedAudits: number;
    completedAuditJSON: string;
    greenRedPalette = {
        domain: ['#28a745', '#dc3545']
    }

    //pie
    showLabels = true;

 

    constructor() { }

    ngOnInit() {
        this.completedAuditJSON = JSON.stringify(this.completed);
        this.completedAudits = this.completed.find(x => x.name === 'Completed').value;
    }

}
